import BlockForm from './form';
import React from 'react';
import Block from '../../../models/block';
import Minisite from '../../../models/minisite';
import PropTypes from 'prop-types';
import { ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function BlockFormContainer({
    organization,
    minisite,
    eventLanguage,
    tabIndex,
    additionnalData,
    blocks,
    place,
    currentBlock,
    currentPosition,
    onSuccess,
    onCloseModal,
    hasTranslationCapability
}) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const save = React.useCallback(data => {
        if (currentBlock) {
            // We found a block, we have to update it
            const newBlock = new Block();
            newBlock.id = currentBlock.id;
            if (currentBlock.event) {
                newBlock.event = currentBlock.event;
            }
            newBlock.payload = { ...data };
            newBlock
                .save({ organizationId: organization.id, siteId: minisite.get('id') })
                .then(() => {
                    onSuccess();
                    toast.success(t('ticket.event.minisite.block.editSuccess'));
                })
                .catch(e => {
                    console.error(e);
                    toast.error(t('ticket.event.minisite.block.editError'));
                });
        } else {
            // No block found, we have to create a block first & link it to the minisite
            const newMinisite = new Minisite();
            newMinisite.id = minisite.get('id');

            const block = new Block();
            block.type = data.type;
            block.name = data.name;
            block.payload = { ...data, type: undefined, name: undefined };
            block
                .save({ organizationId: organization.id, siteId: minisite.get('id') })
                .then(({ response }) => {
                    onSuccess();
                    const placements = [{ block: response.id, name: place, position: currentPosition !== null ? currentPosition : -1 }];
                    newMinisite.tabs = [
                        {
                            id: minisite.tabs[tabIndex].id,
                            placements
                        }
                    ];
                    newMinisite
                        .save({ organizationId: organization.id })
                        .then(() => {
                            onSuccess();
                            toast.success(t('ticket.event.minisite.block.createSuccess'));
                        })
                        .catch(e => {
                            toast.error(t('ticket.event.minisite.block.createError'));
                            console.error(e);
                        });
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }, []);

    return (
        <BlockForm
            onSubmit={save}
            blocks={blocks}
            place={place}
            initialBlock={currentBlock}
            additionnalData={additionnalData}
            organization={organization}
            onCloseModal={onCloseModal}
            eventLanguage={eventLanguage}
            siteLanguage={minisite.language}
            hasTranslationCapability={hasTranslationCapability}
        />
    );
}

BlockFormContainer.propTypes = {
    organization: PropTypes.object.isRequired,
    blocks: PropTypes.array.isRequired,
    minisite: PropTypes.object.isRequired,
    eventLanguage: PropTypes.string.isRequired,
    tabIndex: PropTypes.number.isRequired,
    place: PropTypes.string.isRequired,
    additionnalData: PropTypes.object,
    currentBlock: PropTypes.object,
    onSuccess: PropTypes.func,
    onCloseModal: PropTypes.func
};

BlockFormContainer.defaultProps = {
    additionnalData: {}
};
